"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toInnerRectKeepingAspectRatio = exports.toInnerRectSizeKeepingAspectRatio = void 0;
var rect_size_1 = require("../../types/record/rect-size");
var rectangle_1 = require("../../types/record/rectangle");
/**
 * @description 縦横比を維持して表示するための位置計算
 *
 * @example innerが横長な場合
 *
 *                outer
 *      +--------------------------+  ----+
 *      |                          |      | = padNS
 *      +--------------------------+  ----+
 *      |                          |
 *      |                          |
 *      |          inner           |
 *      |                          |
 *      |                          |
 *      +--------------------------+  ----+
 *      |                          |      | = padNS
 *      +--------------------------+  ----+
 *
 */
var toInnerRectSizeKeepingAspectRatio = function (outerRectSize, aspectRatio) {
    if (aspectRatio <= 0 || !Number.isFinite(aspectRatio)) {
        return outerRectSize;
    }
    var oh = outerRectSize.height, ow = outerRectSize.width;
    if (ow < aspectRatio * oh) {
        // ow / oh < aspectRatio
        // outerがinnerより縦長のとき
        var padNSx2_1 = oh - ow / aspectRatio;
        return outerRectSize.update('height', function (h) { return h - padNSx2_1; });
    }
    else {
        // outerがinnerより横長のとき
        var padWEx2_1 = ow - oh * aspectRatio;
        return outerRectSize.update('width', function (w) { return w - padWEx2_1; });
    }
};
exports.toInnerRectSizeKeepingAspectRatio = toInnerRectSizeKeepingAspectRatio;
var toInnerRectKeepingAspectRatio = function (outerRect, aspectRatio) {
    var outerHeight = outerRect.height, outerWidth = outerRect.width;
    var _a = (0, exports.toInnerRectSizeKeepingAspectRatio)((0, rect_size_1.IRectSize)({ width: outerWidth, height: outerHeight }), aspectRatio), innerHeight = _a.height, innerWidth = _a.width;
    return (0, rectangle_1.IRect)({
        top: (outerHeight - innerHeight) / 2,
        left: (outerWidth - innerWidth) / 2,
        width: innerWidth,
        height: innerHeight
    });
};
exports.toInnerRectKeepingAspectRatio = toInnerRectKeepingAspectRatio;
